import { z } from 'zod';
export const idSchema = z.string().uuid();
export const isoDateTime = z.string().datetime({ offset: true });
/** A civil date with no time component, e.g. a target date. */
export const civilDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
export const errorCodeSchema = z.enum([
    'bad_request',
    'unauthorized',
    'forbidden',
    'not_found',
    'conflict',
    'too_many_requests',
    'internal',
]);
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        details: z.unknown().optional(),
        requestId: z.string(),
    }),
});
export const okSchema = z.object({ ok: z.literal(true) });
export const readyzSchema = z.union([
    okSchema,
    z.object({ ok: z.literal(false), reason: z.enum(['migrations_pending', 'database_unreachable']) }),
]);
//# sourceMappingURL=common.js.map